import { __require as u } from "./_root.js";
var r, e;
function a() {
  if (e) return r;
  e = 1;
  var o = u(), i = o.Symbol;
  return r = i, r;
}
export {
  a as __require
};
